import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { MyVehiclesPage } from '@/features/vehicles/my-vehicles-page';

export const Route = createFileRoute('/vehicles/')({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/vehicles' } });
	},
	component: MyVehiclesPage,
	staticData: { workspace: true },
});
